/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */

export const SIDEBAR_MENU_SEARCH_MIN_ITEMS = 12;

const MESSAGES: Record<string, { placeholder: string; clear: string; empty: string }> = {
  tr: { placeholder: 'Menüde ara', clear: 'Aramayı temizle', empty: 'Eşleşen menü bulunamadı' },
  en: { placeholder: 'Search menu', clear: 'Clear search', empty: 'No matching menu items' },
  ar: { placeholder: 'البحث في القائمة', clear: 'مسح البحث', empty: 'لا توجد عناصر مطابقة' },
  de: { placeholder: 'Menü durchsuchen', clear: 'Suche löschen', empty: 'Keine passenden Menüpunkte' },
  fr: { placeholder: 'Rechercher dans le menu', clear: 'Effacer la recherche', empty: 'Aucun élément correspondant' },
  es: { placeholder: 'Buscar en el menú', clear: 'Borrar búsqueda', empty: 'No hay elementos coincidentes' },
  it: { placeholder: 'Cerca nel menu', clear: 'Cancella ricerca', empty: 'Nessuna voce corrispondente' },
  ru: { placeholder: 'Поиск в меню', clear: 'Очистить поиск', empty: 'Совпадений в меню нет' },
  zh: { placeholder: '搜索菜单', clear: '清除搜索', empty: '没有匹配的菜单项' },
  ja: { placeholder: 'メニューを検索', clear: '検索をクリア', empty: '一致するメニューがありません' },
};

function normalizeSearchText(value: string): string {
  return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').toLocaleLowerCase();
}

/** Search only the already authorized, visible navigation labels supplied by the host. */
export function matchesSidebarMenuSearch(query: string, ...labels: string[]): boolean {
  const words = normalizeSearchText(query).trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const candidate = normalizeSearchText(labels.join(' '));
  return words.every((word) => candidate.includes(word));
}

export interface SidebarMenuSearchProps {
  value: string;
  onChange: (value: string) => void;
  itemCount: number;
  resultCount: number;
  isCollapsed: boolean;
  locale?: string;
}

export function SidebarMenuSearch({ value, onChange, itemCount, resultCount, isCollapsed, locale = 'tr' }: SidebarMenuSearchProps) {
  if (isCollapsed || itemCount < SIDEBAR_MENU_SEARCH_MIN_ITEMS) return null;
  const { placeholder, clear: clearLabel, empty: emptyLabel } = MESSAGES[locale.toLowerCase().split('-')[0]] ?? MESSAGES.en;

  return (
    <form className="sidebar-menu-search" role="search" aria-label={placeholder}
      autoComplete="off" onSubmit={(event) => event.preventDefault()}>
      <div className="sidebar-menu-search__field">
        <svg className="sidebar-menu-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <circle cx="10.8" cy="10.8" r="6.5" />
          <path d="m16 16 4.4 4.4" />
        </svg>
        <input type="search" name="sidebar-menu-query" value={value} onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Escape' && value) {
              event.preventDefault();
              event.stopPropagation();
              onChange('');
            }
          }}
          aria-label={placeholder} placeholder={placeholder} autoComplete="off" spellCheck={false} maxLength={120} />
        {value && (
          <button type="button" className="sidebar-menu-search__clear" onClick={() => onChange('')} aria-label={clearLabel} title={clearLabel}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <path d="M6 6 18 18M18 6 6 18" />
            </svg>
          </button>
        )}
      </div>
      {value && resultCount === 0 && <div className="sidebar-menu-search__empty" role="status">{emptyLabel}</div>}
    </form>
  );
}
